<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">2.</span>
          <span>Eligibility Criteria</span>
        </div>
        <p>Please enter information regarding your eligibility for WIOA.</p>
        <el-form
          :model="eligibilityCriteria"
          @submit.native.prevent="updateCheckList"
        >
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you authorized to work in the United States?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.EligibilityCriteria.AuthorizedToWork.IsAuthorizedToWork'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      eligibilityCriteria.authorizedToWork.isAuthorizedToWork
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload completed
                  <i>Authorized to Work in the US</i> Form.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="authorizedToWork"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon authorizedToWork"
                    :multiple="false"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="authorizedToWorkFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: Authorization to work in the United States can be verified
              through eligibility for unemployment benefits. Documentation of
              this eligibility is included on the Authorized to Work in the US
              form.
            </div>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">What is your birth date?</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.EligibilityCriteria.BirthDate.ClientBirthDate'
                    )
                  "
                >
                  <el-date-picker
                    v-model="eligibilityCriteria.birthDate.clientBirthDate"
                    type="date"
                    placeholder="MM/DD/YYY"
                    value-format="MM/dd/yyyy"
                    format="MM/dd/yyyy"
                    size="small"
                    :picker-options="pickerBeginDateBefore"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload documentation confirming your birth
                  date.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="birthDate"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon birthDate"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="birthDateFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                  <p class="heavy-text">
                    What documentation can confirm my birth date?
                    <em @click="showBirthDateDialog">Click here</em>
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <p class="heavy-text">Selective Service Registration Status</p>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you registered for Selective Service?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.EligibilityCriteria.SelectiveServiceRegistration.IsSelectiveServiceRegistered'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      eligibilityCriteria.selectiveServiceRegistration
                        .isSelectiveServiceRegistered
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload Selective Service System letter/registration
                  letter, DD-214, Certificate of Release or Discharge from
                  Active Duty .</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="selectiveServiceRegistration"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon selectiveServiceRegistration"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="selectiveServiceRegistrationList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: Selective Service Registration can also be confirmed by your
              Case Manager through Internet Verification or Telephone
              verification if documentation is not available.
            </div>
          </div>
          <p class="heavy-text">Dislocated Worker</p>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Would you consider yourself dislocated worker?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.EligibilityCriteria.IsDislocatedWorker'
                    )
                  "
                >
                  <el-radio-group
                    v-model="eligibilityCriteria.isDislocatedWorker"
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <el-dialog
          style="z-index: 1000;"
          :visible="displayBirthDateDialog"
          :show-close="true"
          width="750px"
        >
          <div slot="title">
            <el-row>
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; padding: 15px 0px 15px 0px; text-align: left"
              >
                <span style="font-size: 25px;"><b>Birth Date</b></span
                ><br />
                <span style="font-size: 15px;"
                  >What documentation can confirm my birthdate?</span
                >
              </el-col>
            </el-row>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeBirthDateDialog"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>

          <el-divider></el-divider>
          <el-row>
            <el-col
              :xl="24"
              :lg="24"
              :md="24"
              :xs="24"
              :sm="24"
              style="padding: 15px 0px 15px 0px; text-align: left"
            >
              <span>-Birth certificate </span><br />
              <span>-Baptismal record </span><br />
              <span
                >-DD-214, Certificate of Release or Discharge from Active Duty </span
              ><br />
              <span>-Driver’s license </span><br />
              <span
                >-Federal, state, or local government identification card </span
              ><br />
              <span>-Hospital record of birth </span><br />
              <span>-Passport </span><br />
              <span>-Public assistance/social service records</span><br />
              <span>-School records </span><br />
              <span>-School identification card </span><br />
              <span>-Work permit </span><br />
              <span>-Native American tribal document </span><br />
              <span
                >-Other official document issued by a federal, state, or local
                government Career Center, such as discharge documents from the
                Department of Criminal Justice with date of birth
                included.</span
              ><br />
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      pickerBeginDateBefore: {
        disabledDate(time) {
          console.log("111");
          return time.getTime() > Date.now();
        }
      },
      displayBirthDateDialog: false,
      modelState: {},
      loading: false,
      authorizedToWorkFileList: [],
      birthDateFileList: [],
      selectiveServiceRegistrationList: [],
      eligibilityCriteria: {
        authorizedToWork: {
          isAuthorizedToWork: null,
          clientFiles: []
        },
        birthDate: {
          clientBirthDate: null,
          clientFiles: []
        },
        selectiveServiceRegistration: {
          isSelectiveServiceRegistered: null,
          clientFiles: []
        }
      },
      newAuthorizedToWorkUploadInd: false,
      newBirthDateUploadInd: false,
      newSelectiveServiceRegistrationUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newAuthorizedToWorkUploadInd || this.newBirthDateUploadInd || this.newSelectiveServiceRegistrationUploadInd)
        {
            if(this.eligibilityCriteria.authorizedToWork.clientFiles[0].fileId && this.newAuthorizedToWorkUploadInd){
              this.navigateAwayRemoveAttachment(this.eligibilityCriteria.authorizedToWork.clientFiles[0].fileId);
              this.eligibilityCriteria.authorizedToWork.clientFiles = [];
            }
            
            if(this.eligibilityCriteria.birthDate.clientFiles[0].fileId && this.newBirthDateUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.eligibilityCriteria.birthDate.clientFiles[0].fileId);
              this.eligibilityCriteria.birthDate.clientFiles = [];
            }
              
            if(this.eligibilityCriteria.selectiveServiceRegistration.clientFiles[0].fileId && this.newSelectiveServiceRegistrationUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.eligibilityCriteria.selectiveServiceRegistration.clientFiles[0].fileId);
              this.eligibilityCriteria.selectiveServiceRegistration.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0, 0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          if (res.checklist.eligibilityCriteria) {
            this.eligibilityCriteria = res.checklist.eligibilityCriteria;
            res.checklist.eligibilityCriteria.authorizedToWork.clientFiles.forEach(
              element => {
                this.authorizedToWorkFileList.push({
                  name: element.fileName,
                  url: element.fileId
                });
              }
            );
            res.checklist.eligibilityCriteria.birthDate.clientFiles.forEach(
              element => {
                this.birthDateFileList.push({
                  name: element.fileName,
                  url: element.fileId
                });
              }
            );
            res.checklist.eligibilityCriteria.selectiveServiceRegistration.clientFiles.forEach(
              element => {
                this.selectiveServiceRegistrationList.push({
                  name: element.fileName,
                  url: element.fileId
                });
              }
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList) {
      let uploadElement =
        event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url =
        file.url == null && file.name != null ? file.raw.url : file.url;
      const param = {
        objectId: file.url,
        bucketType: BucketType.WioaChecklist
      };
      this.$store
        .dispatch("common/removefile", param)
        .then(() => {
          if (uploadElement.classList.contains("authorizedToWork")) {
            this.eligibilityCriteria.authorizedToWork.clientFiles = [];
          } else if (uploadElement.classList.contains("birthDate")) {
            this.eligibilityCriteria.birthDate.clientFiles = [];
          } else if (
            uploadElement.classList.contains("selectiveServiceRegistration")
          ) {
            this.eligibilityCriteria.selectiveServiceRegistration.clientFiles = [];
          }
          this.$message.success("Document removed!");
        })
        .catch(res => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleExceed() {
      this.showPopUpMessage("Upload", `You can only upload 1 file.`);
    },
    showBirthDateDialog() {
      this.displayBirthDateDialog = true;
    },
    closeBirthDateDialog() {
      this.displayBirthDateDialog = false;
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklist",
        params: { checklistId: this.checklistId }
      });
    },
    updateCheckList() {
      this.loading = true;
      this.eligibilityCriteria.birthDate.clientBirthDate =
        this.eligibilityCriteria.birthDate.clientBirthDate == null ||
        this.eligibilityCriteria.birthDate.clientBirthDate == ""
          ? null
          : new Date(this.eligibilityCriteria.birthDate.clientBirthDate);
      let checklist = {
        type: 1,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          eligibilityCriteria: this.eligibilityCriteria
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistThree",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          if (param.action == "authorizedToWork") {
            this.eligibilityCriteria.authorizedToWork.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newAuthorizedToWorkUploadInd = true;
          } else if (param.action == "birthDate") {
            this.eligibilityCriteria.birthDate.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newBirthDateUploadInd = true;
          } else {
            this.eligibilityCriteria.selectiveServiceRegistration.clientFiles.push(
              {
                fileId:
                  this.editChecklistId == null
                    ? this.getChecklistId()
                    : this.editChecklistId +
                      "/JobSeeker/" +
                      metadata.documentId,
                fileName: file.name
              }
            );
            this.newSelectiveServiceRegistrationUploadInd = true;
          }
          param.file.url =
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  word-break: break-word;
}

.el-icon-document,
.el-icon-close {
  margin: 0px !important;
}

.el-upload__input {
  display: inherit;
}
</style>
